import moment from "moment";

// How many separate lesson sessions a course needs. Prefers the day-count in
// the course title (e.g. "40-Hour Intensive Course (7 Days)" -> 7) since that's
// how the school actually structures block courses; falls back to one 2-hour
// session per block for courses with no day-count in the title.
export const getRequiredSessionCount = (course) => {
  const dayMatch = `${course?.title || ''}`.match(/(\d+)\s*-?\s*days?/i);
  if (dayMatch) return Math.max(1, Number(dayMatch[1]));

  const hours = (Number(course?.practical) || 0) + (Number(course?.theory) || 0);
  return Math.max(1, Math.ceil(hours / 2));
};

// Builds the backend "slots" payload from the individual dates/times the
// student picked themselves (see SlotSelection.js) instead of silently
// auto-allocating every session on consecutive weekdays.
export const buildSlotsPayload = (sessions) => {
  return sessions.map((session, index) => ({
    id: index + 1,
    date: moment(session.date).format("DD-MM-YYYY"),
    time: session.time,
    status: 1,
    instructorFeedback: [],
    customerFeedback: [],
    isClaimed: false,
  }));
};
